import { ROUTE_GET_CONSTRAINTS } from '@/constants';
import Constraint, { SerializedConstraint } from '@/classes/Constraint/Constraint';
import ConstraintValidator from '@/validators/ConstraintValidator';
import axios from 'axios';

export const getAllConstraintsRequest = async (): Promise<Constraint[]> => {
  const serializedConstraints: Array<Record<string, unknown>> = (await axios.get(ROUTE_GET_CONSTRAINTS)).data
  ConstraintValidator.validateConstraints(serializedConstraints)
  return serializedConstraints.map(serializedConstraint => Constraint.deserialize(serializedConstraint as unknown as SerializedConstraint))
}